import { RG_TYPE as n, getRgObjectsOfType as w } from "@project-rouge/rg-core";
import { Matrix4 as _, Vector3 as r, Quaternion as M, ExtrudeGeometry as z } from "three";
import { createShape as P } from "../../3d/create-geometry/index4.js";
import { getMatrix as y } from "../../geometry-utils/three/index9.js";
import { VisibilityPresets as S } from "../../utils/visibility/index3.js";
import { changeColorFuncUkV1V2 as E } from "../../colors/internal/index.js";
const G = new _().makeRotationX(Math.PI * 0.5), h = new r(), d = new r(), x = new r(), g = new r(), a = new M(), f = new r(), R = [n.EmptySpace, n.TechnicalSpace];
function q({ obj: t, colourFunc: i = E }) {
  return u({ obj: t, colourFunc: i });
}
function u({
  obj: t,
  parent: i,
  colourFunc: o,
  parentMx: c,
  renderData: e = { matrices: [], colors: [], extrudeGeometries: [] }
}) {
  const s = y(t);
  if (c && s.premultiply(c), R.includes(t.type)) {
    if (!c)
      return e;
    const p = t.data.polygon;
    if (!p)
      return e;
    const l = P(p), m = new z(l, {
      depth: t.size[1],
      bevelEnabled: !1
    });
    return y({
      ...t,
      pos: [t.pos[0], t.pos[1] + t.size[1], t.pos[2]]
    }, s).multiply(G).premultiply(c), m.applyMatrix4(s), m.userData.color = o ? o(t, i)[0] : t.color, e.extrudeGeometries.push(m), e;
  }
  if (t.type === n.Apartment) {
    const p = w(t, n.Module);
    for (const l of p)
      u({ obj: l, parent: t, colourFunc: o, renderData: e, parentMx: s });
    return e;
  }
  if (S.abstract.includes(t.type))
    return s.decompose(h, a, f), d.set(...t.size), x.set(...t.anchor), g.copy(x).negate().addScalar(0.5).multiply(d).applyQuaternion(a), s.compose(
      h.add(g),
      a,
      f
    ), s.scale(f.set(...t.size)), e.matrices.push(s.toArray()), e.colors.push(o ? o(t, i)[0] : t.color), e;
  for (const p of t.children)
    u({ obj: p, parent: t, colourFunc: o, renderData: e, parentMx: s });
  return e;
}
export {
  q as getAbstractMeshProps
};
//# sourceMappingURL=index2.js.map
